import { useSyncExternalStore } from 'react';

export function readCsrfToken(): string | null {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  return meta?.content ?? null;
}

// `<meta name="csrf-token">` の content 変化を購読し、Inertia の SPA ナビゲーション
// 直後に meta タグが非同期で差し替えられるケースにも追随する。
// React の useSyncExternalStore で「外部 store の値」として扱うことで、サブスクリプション
// と同期スナップショットの整合を保つ。
// 監視対象は `content` 属性と `<head>` 直下の childList のみに絞り、Inertia の <title> /
// <link> 差し替えや HMR で無駄なコールバックが発火するのを抑える。
function subscribeCsrfToken(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.head, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['content'],
  });
  return () => observer.disconnect();
}

export function useCsrfToken(): string | null {
  return useSyncExternalStore(subscribeCsrfToken, readCsrfToken, () => null);
}
